import React, {useState} from 'react'
import {DateTime} from 'luxon';
import NumberFormat from 'react-number-format';

export default function SummaryChargesDetails(props) {
    const [page, setPage] = useState(0);
    const itemsPerPage = 3;

    const {charges, isExpanded, contentId, isMobileOrDesktop} = props;

    const startIndex = page * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedPayments = charges.futurePayments.slice(startIndex, endIndex);

    const hasPrevious = page > 0;
    const hasNext = endIndex < charges.futurePayments.length;

    function getFormattedDate(dateToFormat) {
        let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
        return formattedDate;
    }

    return (
        <div>
            <div class="wth3-summaryCharges__top">
                <h3 class="wth3-summaryCharges__top-title" id="css_summaryOfChargesHeader">Summary of charges</h3> 
                <div className="wth3-summaryCharges__top-openClose">
                    {isExpanded ? <i class="fas fa-angle-up" aria-hidden='true'></i> : <i class="fas fa-angle-down" aria-hidden='true'></i>}
                </div>
            </div>

            {/* Summary charges: Container */}
            <div id={isMobileOrDesktop ? contentId : 'cssSummaryChargesContent'} class="wth3-summaryCharges__bottom" style={{display: isMobileOrDesktop ? isExpanded ? 'block' : 'none' : 'block'}}  onClick={(e) => e.stopPropagation()}>
                
                {/* Summary charges: Total */}
                <dl class="wth3-summaryCharges__bottom-total">
                    <dt id="css_charges_totalCostLabel">Total</dt>
                    <dd id="css_chargesTotalCost" ><NumberFormat value={charges.totalcost} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></dd>
                </dl>
                
                {/* Summary charges: Insurance */}
                <dl class="wth3-summaryCharges__bottom-insurance">
                    <dt id="css_charges_travelProtectionLabel" class="wth3-summaryCharges__bottom-insurance-labelBox">
                        <span className='wth3-insuranceLabel'>Travel Insurance</span>
                        {charges.pageId === 'payment' && charges.insuranceHasVendor &&
                            <span class="wth3-summaryCharges__bottom-insurance-labelBox-insurProviderName" id="insuranceProvider">{charges.insuranceVendor}</span>
                        }
                    </dt>
                    <dd id="css_chargesTravelProtection">{charges.insuranceStatus}</dd>
                </dl>

                {/* Summary charges: Amount Paid */}
                {charges.pageId === 'payment' && 
                <dl class="wth3-summaryCharges__bottom-amountPaid">
                    <dt id="css_charges_paymentsToDateLabel">Completed Payments</dt>
                    <dd id="css_chargesPaymentsToDate">
                        {charges.paymentToDate !== 0 &&
                            <span>-<NumberFormat value={charges.paymentToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                        }
                        {charges.paymentToDate === 0 &&
                            <span><NumberFormat value={charges.paymentToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                        }
                    </dd>
                </dl>
                } 

                {/* Summary charges: Amount Paid */}
                {charges.pageId === 'confirmation' && 
                <dl class="wth3-summaryCharges__bottom-amountPaid">
                    <dt id="css_conf_paymentsAppliedLabel">Completed Payments</dt>
                    <dd id="css_conf_paymentsApplied">
                        {charges.paymentToDate !== 0 &&
                            <span>-<NumberFormat value={charges.paymentToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                        }
                        {charges.paymentToDate === 0 &&
                            <span><NumberFormat value={charges.paymentToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
                        }
                    </dd>
                </dl>
                } 
               
                {/* Summary charges: Todays Payment */}
                {charges.pageId === 'confirmation' && charges.todaysPayment &&
                <div>
                    <dl class={`wth3-summaryCharges__bottom-todaysPayment ${charges.newFuturePayments ? 'wth3-isTodaysPaymentPadding' : ''}`}>
                        <dt id="css_conf_newPaymentLabel">Today's Payment</dt>
                        <dd id="css_conf_newPayment">
                            <span>-<NumberFormat value={charges.todaysPayment} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>                  
                        </dd>
                    </dl>

                    {charges.newFuturePayments &&
                    <div>
                        <span class="wth2-warningMessageHeaderConfirmation">*</span>
                        <div class="wth2-warningMessageHeaderConfirmation wth2_css_confirmationLine3" id="css_conf_paymentPending">Payment pending - See Note Below</div>
                    </div>
                    }
                </div>
                }

                
                <div class="wth3-summaryCharges__bottom-balanceDueDate">
                    {/* Summary charges: Remaining Balance */}
                    <dl class="wth3-summaryCharges__bottom-balanceDueDate-remainingBalance">
                        {charges.pageId === 'payment' &&
                        <>  
                            {(charges.remainingBalanceNegative === true|| charges.chargesRemainingBalance === 0 || charges.remainingBalance === 0) &&
                                <dt><span id="css_paidInFull">{charges.paidInFullLanguage}</span></dt> 
                            }
                            <dt><span id="css_balanceDueLabel">{charges.balanceDue.replace(/:/g, '')}</span></dt>
                            {charges.remainingBalanceNegative===false && charges.remainingBalance!==0 &&
                                <dd id="css_chargesRemainingBalance"><NumberFormat value={charges.remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></dd>
                            }
                        </>
                        }
                        {charges.pageId === 'confirmation' && charges.remainingBalance &&
                        <>
                            <dt id="css_balanceDueLabel">Remaining balance</dt>
                            <dd id="css_chargesRemainingBalance">
                                <NumberFormat value={charges.remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                            </dd>
                        </>
                        }
                        {charges.pageId === 'confirmation' && charges.paidInFullLanguage &&
                        <>
                            <dt id="css_balanceDueLabel">Remaining balance</dt>
                            <dd id="css_chargesRemainingBalance">
                                <span id="css_paidInFull">{charges.paidInFullLanguage}</span>
                            </dd>
                        </>
                        }
                    </dl>

                    {/* Summary charges: Payment Due */}
                    {charges.pageId === 'payment' && charges.bookingPastDue===false && charges.remainingBalance!==0 && charges.cruiseLineName !== 'Viking River' && charges.cruiseLineName !== 'Viking Ocean' &&
                        <dl id="css_paymentDueDate" class="wth3-summaryCharges__bottom-balanceDueDate-amountPaidTotal">
                            <dt>{charges.paymentDue}</dt>
                        </dl>
                    }
                    {/* Summary charges: Payment Due */}
                    {charges.pageId === 'payment' && !charges.remainingBalanceNegative &&  charges.chargesRemainingBalance!=='0.0' && charges.remainingBalance!==0 && charges.bookingPastDue === true &&
                        charges.cruiseLineName !== 'Viking River' && charges.cruiseLineName !== 'Viking Ocean' &&
                            <dl id="css_paymentDueDate" class="wth3-summaryCharges__bottom-balanceDueDate-amountPaidTotal">
                                <dt>Payment was due on {getFormattedDate(charges.chargesPaymentDueDate)}</dt>
                            </dl> 
                    }
                    {/* Summary charges: Payment Due */}
                    {charges.pageId === 'confirmation' && charges.chargesPaymentDueDate && !charges.paidInFullLanguage &&
                        <dl id="css_paymentDueDate" class="wth3-summaryCharges__bottom-balanceDueDate-amountPaidTotal">
                            <dt>Payment due {getFormattedDate(charges.chargesPaymentDueDate)}</dt>
                        </dl>
                    }
                </div>

                
                {/* {/* Summary charges: Scheduled payments */} 
                {charges.futurePayments.length !== 0 && 
                    <div class="wth3-summaryCharges__bottom-scheduledPayment" id="css_scheduledPaymentsContainer">
                        <dl class="wth3-summaryCharges__bottom-scheduledPayment-header" id="css_scheduledPaymentsHeader">
                            <dt class="wth3-summaryCharges__bottom-scheduledPayment-header-title">Scheduled Payments</dt>
                            <dd class="wth3-summaryCharges__bottom-scheduledPayment-header-total">
                                <span id="css_scheduledPaymentsTotal">
                                    <NumberFormat value={charges.scheduledPayment} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> in total
                                </span>
                            </dd> 
                        </dl>
                        
                        {paginatedPayments.map((futurepayments, index) => (
                            <div id={"css_futurePayment_" + index} className='wth3-summaryCharges__bottom-scheduledPayment-item'>
                                <div className='wth3-summaryCharges__bottom-scheduledPayment-item-leftDetails'>
                                    <span id={"css_futurePayment" + index + "_fpdate"} className='wth3-summaryCharges__bottom-scheduledPayment-item-leftDetails-fpDate'>
                                        {futurepayments.futurePaymentDate}
                                    </span>
                                    <div className='wth3-summaryCharges__bottom-scheduledPayment-item-leftDetails-cardInfo'>
                                        <span className="css_futurePaymentCCType" id={"css_futurePayment" + index + "_cctype"}>
                                            {futurepayments.creditCardType.replace("(R)", "\u00AE").toLowerCase()}
                                        </span> 
                                        <span>ending in</span>
                                        <span id={"css_futurePayment" + index + "_ccnum"}>{futurepayments.maskedCreditCardNumber.slice(-4)}</span>
                                    </div>
                                </div>  
                                <span id={"css_futurePayment" + index + "_amount"} className='wth3-summaryCharges__bottom-scheduledPayment-item-rightDetails'>
                                    <NumberFormat value={futurepayments.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
                                </span>
                            </div>
                        ))}

                        {charges.futurePayments.length > 3 &&
                            <div className='wth3-summaryCharges__bottom-scheduledPayment-nav'>
                                {hasPrevious &&
                                    <a href="# " id='summaryChargesPrevious' className='wth3-summaryCharges__bottom-scheduledPayment-nav-previous' 
                                        onClick={(e) => {e.preventDefault(); setPage(page - 1)}} 
                                        onKeyDown={(e) => {e.preventDefault(); if (e.key === 'Enter' || e.key === ' ') {setPage(page - 1)}}} 
                                    ><i class="fas fa-chevron-left" aria-hidden="true"></i> Previous</a>
                                }

                                {hasNext &&
                                    <a href="# " id='summaryChargesNext' className='wth3-summaryCharges__bottom-scheduledPayment-nav-next' 
                                        onClick={(e) => {e.preventDefault(); setPage(page + 1)}} 
                                        onKeyDown={(e) => {e.preventDefault(); if (e.key === 'Enter' || e.key === ' ') {setPage(page + 1)}}} 
                                    >Next <i class="fas fa-chevron-right" aria-hidden="true"></i></a>
                                }
                            </div>
                        }
                    </div>   
                }

            {charges.pageId === 'payment' && charges.futurePaymentsRemoved === true && !charges.bookingPastDue && charges.paymentDue !== "" && charges.payRemainingBalance >= 25 &&
                <div id="scheduledPaymentWiseMessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg wth2-warningMessage" aria-hidden="true">
                    <i class="fa fa-exclamation-circle " aria-hidden="true"></i>
                    <div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
                    <div id="scheduledPaymentWiseMessageText">Some payments that are scheduled to be paid in the next 5 days may not be paid online now.</div>		
                </div>						
            }

            {charges.pageId === 'payment' && charges.payRemainingBalance < 25 && charges.insuranceStatus !== 'Included' &&
                <div id="lessThan25MessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg lessThan25MessageWraper wth2-informationMessage wth3-lessThan25MsgSOC" aria-hidden="true">
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    <div id="lessThan25WiseMessageHeader" class="wth2-informationMessageHeader">Please Note:</div>
                    <div id="lessThan25WiseMessageText">Balances below $25.00 cannot be paid online. To complete your payment, please call us at {charges.cruisePhone}.</div>		
                </div>						
            }

            {charges.pageId === 'confirmation' && charges.scheduledPaymentHasChanged &&
                <div>
                    <div id="scheduledPaymentWiseMessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg wth2-warningMessage" aria-hidden="true">
                        <i class="fa fa-exclamation-circle " aria-hidden="true"></i>
                        <div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
                        <div id="scheduledPaymentWiseMessageText">Today&#39;s payment reduced the amount of a previously scheduled payment. Your current scheduled payments (if any) are reflected in the Summary of Charges above.</div>		
                    </div>						
                </div>
            }
            {charges.pageId === 'confirmation' && charges.newFuturePayments &&
                <div>
                    <div id="newScheduledPaymentWiseMessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg wth2-warningMessage" aria-hidden="true">
                        <i class="fa fa-exclamation-circle " aria-hidden="true"></i>
                        <div id="newScheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
                        <div id="newScheduledPaymentWiseMessageText">Today&#39;s payment(or a portion of the payment) will be processed on the next business day, and is shown as a new scheduled payment.  Your Remaining Balance will be updated once your payment is processed.</div>		
                    </div>						
                </div>
            }
            
            </div>

        </div>
    )
}
